export enum ProductType {
  ACCOUNT = "account",
  INTEGRATION = "integration",
  MICRO_TRANSACTION = "micro_transaction",
  SUPPORT_SERVICE = "support_service",
}
